import { Injectable, SetMetadata } from '@nestjs/common';

/**
 * 自动化控制器元数据键
 */
export const AUTOMATION_METADATA_KEY = 'automation:controller';

/**
 * @Automation 装饰器
 * 
 * 类装饰器，用于标记一个类为自动化任务控制器
 * 自动包含 @Injectable()，无需额外添加
 * 
 * @example
 * ```typescript
 * @Automation()
 * export class MyAutomation {
 *   // 任务方法
 * }
 * ```
 */
export const Automation = (): ClassDecorator => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return (target: any) => {
    // 应用 Injectable 装饰器
    Injectable()(target);
    // 设置自动化元数据
    SetMetadata(AUTOMATION_METADATA_KEY, true)(target);
    return target;
  };
};
